import { ViewEmployees } from '../../pages';
import React, { useState } from 'react';
import { employeeStore, userStore } from '../../stores';
import { observer } from 'mobx-react';
import { MimaToastUtil } from '../../components';
import { useNavigate } from 'react-router-dom';
import constant from '../../utils/constant';

const ViewEmployeesContainer = ({ closeModal }) => {
	const [addEmployee, setAddEmployee] = useState(false);
	const [specificEmployee, setSpecificEmployee] = useState(false);
	const navigate = useNavigate();

	const isOnboardingDone = () => {
		if (userStore.isOnBoardingDone === 'false') {
			MimaToastUtil.error({
				message: constant.OnboardingRequired,
			});
			localStorage.setItem(constant.RoutePath, constant.Routes.Employees);
			return navigate(constant.Routes.OnboardingStageOne);
		}
	}
	const showAddEmployee = () => {
		// isOnboardingDone();
		setAddEmployee(true);
	};

	const showSpecificEmployee = (employeeId) => {
		const selectedEmployee = employeeStore.activeEmployees.filter(employee => employee._id === employeeId)[0];
		employeeStore.setSelectedEmployee(selectedEmployee);
		setSpecificEmployee(true);
	};

	return (
		<ViewEmployees
			closeModal={closeModal}
			employees={employeeStore.mappedEmployees}
			addEmployee={addEmployee}
			showAddEmployee={showAddEmployee}
			specificEmployee={specificEmployee}
			showSpecificEmployee={showSpecificEmployee}
		/>
	);
};

export default observer(ViewEmployeesContainer);
